<template>
<main>
    <breadcrumbs></breadcrumbs>
        <iframe class="contact-map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2470.655120437038!2d4.553451914900891!3d51.73934310154003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c425345c79abc1%3A0x2e583661490c5f9!2sSchenkeldijk%2045%2C%203291%20EN%20Strijen!5e0!3m2!1snl!2snl!4v1574333753867!5m2!1snl!2snl" height="450" frameborder="0" style="border:0;" allowfullscreen=""></iframe>
    <div class="content-wrapper">

        <div class="content-width">
          <p>
            Kom nu in contact zodat we zo snel mogelijk aan een oplossing kunnen werken.<br/>
            U kunt ons via de mail of telefonisch bereiken.
          </p>
          <ul class="pretty">
            <li><div class="name">E-mail</div>{{ information.email}}</li>
            <li><div class="name">Telefoon</div>{{ information.telephoneNumber }}</li>
            <li><div class="name">KvK</div>{{ information.kvk }}</li>
            <li><div class="name">Adres</div>{{ information.street }}, {{ information.city }}</li>
            <li><div class="name">BTW</div>{{ information.btw }}</li>
          </ul>
        </div>
    </div>
</main>
</template>

<script>

import Breadcrumbs from './breadcrumbs'
import information from '../configurables/information.js'

export default {
  name: 'ContentTakenpakket',
  components: {
      Breadcrumbs,
  },
  data () {
    return {
      information
    }
  },
  mounted() {
    window.scrollTo(0, 0);
  }
}
</script>

<style>
  .contact-map {
    width: 100%;
    height: 280px;
    margin-bottom: -6px;
  }
</style>


// WEBPACK FOOTER //
// src/components/content-contact.vue